export default __webpack_public_path__ + "static/media/Digital transformation.825c654a.png";